// extracted by mini-css-extract-plugin
export var cardSelected = "_jh-2";
export var image = "_jh-1";
export var table = "_jh-0";